define("shared/components/shared/social-set-icons", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "later/utils/constants"], function (_exports, _component, _templateFactory, _component2, _constants) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"later/utils/constants"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <span class="tPF--social__icon">
    {{#each this.socialPlatforms as |platform|}}
      {{svg-jar (concat "social-" platform) class="o--icon o--icon--sm o--icon--light tPF--plan__icon"}}
    {{/each}}
  </span>
  */
  {
    "id": "NXhV5xoI",
    "block": "[[[10,1],[14,0,\"tPF--social__icon\"],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,0,[\"socialPlatforms\"]]],null]],null],null,[[[1,\"    \"],[1,[28,[35,2],[[28,[37,3],[\"social-\",[30,1]],null]],[[\"class\"],[\"o--icon o--icon--sm o--icon--light tPF--plan__icon\"]]]],[1,\"\\n\"]],[1]],null],[13]],[\"platform\"],false,[\"each\",\"-track-array\",\"svg-jar\",\"concat\"]]",
    "moduleName": "shared/components/shared/social-set-icons.hbs",
    "isStrictMode": false
  });

  class SocialSetIconsComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "socialPlatforms", [_constants.SocialProfileType.Instagram, _constants.SocialProfileType.Facebook, _constants.SocialProfileType.Twitter, _constants.SocialProfileType.Pinterest, _constants.SocialProfileType.Tiktok, _constants.SocialProfileType.Linkedin]);
    }

  }

  _exports.default = SocialSetIconsComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SocialSetIconsComponent);
});